import axios from "axios";
import { reject } from "lodash";
// import router from './../../../router'

export const getAkuns = ({ commit }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    return new Promise((resolve, reject) => {
        axios
            .get(
                "/api/get-akuns/" + payload.role + "/" + payload.user_jensek_id
            )
            .then(response => {
                commit("SET_AKUN", response.data);
                commit("SET_OVERLAY", false, { root: true });
                resolve("ok");
            })
            .catch(errors => {
                reject("fail");
            });
    });
};

// export const storeSekolah = ({ commit, dispatch }, sekolah) => {
//     commit("SET_OVERLAY", true, { root: true });
//     let nama = sekolah.nama;
//     axios.post("api/tambah-sekolah", sekolah).then((response) => {
//         commit("SET_OVERLAY", false, { root: true });
//         let notif = {
//             msg: nama + " Berhasil ditambahkan~",
//             type: "create"
//         }
//         commit("SET_NOTIF", notif, { root: true });
//         dispatch("getSekolahs");
//     });
// }

export const ubahPassword = ({ commit, rootState }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    return new Promise((resolve, reject) => {
        axios
            .put("/api/ubah-password/" + rootState.auth.user.id, payload)
            .then(response => {
                let notif = {
                    msg: "Password berhasil diupdate~",
                    type: "update"
                };
                commit("SET_NOTIF", notif, { root: true });
                resolve("ok");
            })
            .catch(e => {
                const errors = e.response.data.errors;
                const oldPasswordMismatch = !!errors?.old_password;

                console.log(e.response.data);

                if (oldPasswordMismatch) {
                    let notif = {
                        msg: "Password gagal di update!",
                        type: "error"
                    };
                    commit("SET_NOTIF", notif, { root: true });
                }

                reject(e.response.data.errors);
            })
            .finally(() => {
                commit("SET_OVERLAY", false, { root: true });
            });
    });
};

export const resetPassword = ({ commit }, payload) => {
    let nama = payload.nama;
    commit("SET_OVERLAY", true, { root: true });
    axios
        .put("/api/reset-password/" + payload.id)
        .then(response => {
            let notif = {
                msg: "Akun dari " + nama + " berhasil direset~",
                type: "update"
            };
            commit("SET_NOTIF", notif, { root: true });
        })
        .catch(e => {
            console.log(e);
        })
        .finally(() => {
            commit("SET_OVERLAY", false, { root: true });
        });
};

export const tambahAdmin = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    return new Promise((resolve, reject) => {
        axios
            .post("/api/tambah-admin", payload.data)
            .then(res => {
                let notif = {
                    msg: "Admin berhasil ditambahkan~",
                    type: "create"
                };
                let pay = {
                    role: payload.role,
                    user_jensek_id: payload.user_jensek_id
                };
                dispatch("getAkuns", pay).then(() => {
                    commit("SET_NOTIF", notif, { root: true });
                    resolve("ok");
                });
            })
            .catch(e => {
                reject(e.response.data.errors);
                commit("SET_OVERLAY", false, { root: true });
            });
    });
};

export const deleteAkun = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.nama;
    return new Promise((resolve, reject) => {
        axios
            .delete("/api/hapus-akun/" + payload.id)
            .then(response => {
                commit("SET_OVERLAY", false, { root: true });
                let notif = {
                    msg: nama + " Berhasil dihapus~",
                    type: "delete"
                };
                let pay = {
                    role: payload.role,
                    user_jensek_id: payload.user_jensek_id
                };
                dispatch("getAkuns", pay).then(() => {
                    commit("SET_NOTIF", notif, { root: true });
                    resolve("ok");
                });
            })
            .catch(e => {
                reject("fail");
            });
    });
};
